import { GraphQLNonNull, GraphQLObjectType, GraphQLString } from 'graphql';

const AMAudienceCountyType = new GraphQLObjectType({
  name: 'AMAudienceCounty',
  description: 'A County for an ActiveMatch Subscription Audience',
  fields: () => ({
    county: {
      type: new GraphQLNonNull(GraphQLString),
      description: 'ActiveMatch County Audience County',
    },
    state: {
      type: new GraphQLNonNull(GraphQLString),
      description: 'ActiveMatch County Audience State',
    },
  }),
});

export default AMAudienceCountyType;
